import React from 'react';
import { PackageOpen, Check, Clock, Zap, Lock, ShieldCheck } from 'lucide-react';
import { SectionHeader, Button } from '../ui/Shared';
export function OfferSection() {
  const includes = [{
    title: 'Guía Principal SOS Reflujo 11 PM',
    desc: 'El paso a paso exacto para apagar la acidez en minutos.'
  }, {
    title: 'El Método de Purificación de Sábila',
    desc: 'Cómo extraer el cristal correctamente para sanar tu esófago.'
  }, {
    title: 'La Fórmula de Hidratación Peso/7',
    desc: 'Cuánta agua exacta necesita TU cuerpo para crear su propio antiácido.'
  }, {
    title: 'Lista de los 5 Gatillos Silenciosos',
    desc: 'Los alimentos "sanos" que debes eliminar hoy mismo.'
  }, {
    title: 'La Guía de Posicionamiento Nocturno',
    desc: 'Cómo usar la gravedad para que el ácido no suba nunca más.'
  }, {
    title: 'Checklist de 20 Días',
    desc: 'Calendario de seguimiento para asegurar tu recuperación.'
  }];
  return <section id="oferta" className="py-24" data-id="element-263">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-264">
        <SectionHeader tag="Tu oferta completa" title="Recupera tus noches hoy mismo" data-id="element-265" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-12 items-start" data-id="element-266">
          {/* Left Card */}
          <div className="fade-up bg-surface rounded-2xl p-8 md:p-10 border border-white/10" data-id="element-267">
            <h3 className="text-xl font-bold mb-6 text-text-light flex items-center" data-id="element-268">
              <PackageOpen className="w-5 h-5 text-accent mr-2.5" data-id="element-269" />
              Incluido en tu acceso inmediato
            </h3>
            <ul className="space-y-0" data-id="element-270">
              {includes.map((item, idx) => <li key={idx} className="flex items-start gap-3 py-3 border-b border-white/5 last:border-none text-[15px] text-text-muted" data-id="element-271">
                  <Check className="w-4 h-4 text-accent mt-1 shrink-0" data-id="element-272" />
                  <div data-id="element-273">
                    <strong className="text-text-light" data-id="element-274">{item.title}</strong>
                    <br data-id="element-275" />
                    {item.desc}
                  </div>
                </li>)}
            </ul>
          </div>

          {/* Right Card (Sticky) */}
          <div className="scale-in bg-gradient-to-br from-secondary to-[#0F1A2E] rounded-2xl p-8 md:p-10 border border-accent/40 lg:sticky lg:top-24" data-id="element-276">
            <div className="flex justify-center mb-8" data-id="element-277">
              <img src="https://i.postimg.cc/9MBfVQ1x/libro-principal.webp" alt="Protocolo SOS Reflujo 11 PM" className="w-72 md:w-80 h-auto object-contain drop-shadow-[0_16px_40px_rgba(232,160,32,0.3)] rounded-md" data-id="element-278" />
            </div>
            <div className="flex items-baseline gap-4 mb-1" data-id="element-279">
              <span className="price-struck text-2xl md:text-3xl font-bold font-playfair" data-id="element-280">
                120 USD
              </span>
              <span className="text-sm text-text-muted" data-id="element-281">Precio normal</span>
            </div>
            <div className="price-glow font-playfair text-6xl md:text-[84px] font-black text-gradient-gold leading-none mb-1" data-id="element-282">
              12 USD
            </div>
            <p className="text-sm text-accent font-semibold mb-7" data-id="element-283">
              🔥 Precio especial de lanzamiento
            </p>

            <div className="bg-danger/10 border border-danger/20 rounded-lg p-3 mb-6 flex items-center gap-2.5 text-sm text-[#FC8181]" data-id="element-284">
              <Clock className="w-4 h-4 shrink-0" data-id="element-285" />
              <span data-id="element-286">
                Olvida el gasto constante en farmacias y los efectos secundarios
                de los bloqueadores de ácido.
              </span>
            </div>

            <Button href="#cta-final" className="w-full mb-4" data-id="element-287">
              <Zap className="w-5 h-5" data-id="element-288" />
              ¡Sí, quiero apagar el fuego ahora!
            </Button>

            <div className="flex justify-center gap-6 mt-4 mb-4" data-id="element-289">
              <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-290">
                <Lock className="w-3.5 h-3.5 text-accent" data-id="element-291" /> Pago Seguro
              </span>
              <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-292">
                <ShieldCheck className="w-3.5 h-3.5 text-accent" data-id="element-293" /> Garantía 7D
              </span>
            </div>

            <p className="text-xs text-text-muted text-center mt-4 leading-relaxed" data-id="element-294">
              Acceso instantáneo al PDF. Lee en tu celular, tablet o
              computadora.
            </p>
          </div>
        </div>
      </div>
    </section>;
}